import { CATEGORIES } from "@dransay/api/models";

type Category = (typeof CATEGORIES)[keyof typeof CATEGORIES];

const DEFAULT_IMAGE_BY_CATEGORY: Record<Category, string> = {
	[CATEGORIES.FLOWERS]: "flowers.png",
	[CATEGORIES.EXTRACTS]: "extract.jpg",
	// Alias inhalations_extract to extracts default image
	[CATEGORIES.INHALATIONS_EXTRACT]: "inhalations_extract.jpg",
	[CATEGORIES.EDIBLES]: "edibles.png",
	[CATEGORIES.DRINKABLES]: "drinkables.png",
	[CATEGORIES.CAPSULES]: "capsules.png",
	[CATEGORIES.CANNABIS_ACCESSORIES]: "extract.jpg",
};

export const getImageSource = (
	imageUrl: string | null,
	category: string | null,
): string => {
	if (imageUrl) return imageUrl;
	if (!category) return "/images/product-defaults/extract.jpg";

	const defaultFile = DEFAULT_IMAGE_BY_CATEGORY[category as Category];
	return `/images/product-defaults/${defaultFile ?? "extract.jpg"}`;
};
